import { checkEnvironment } from '@saviynt/common';

const getAssetTypeApiUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/endpoints/assettypes`;
};

export default getAssetTypeApiUrl;
